export default __webpack_public_path__ + "static/media/star.246d6175.svg";